export const TOKEN_KEY = 'ishazir_token';
export const USER_KEY = 'ishazir_user';
const FREE_TOOL_KEY = 'ishazir_free_tool_used';

export function saveAuth(token, user) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
  }
  if (user) {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  }
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function getUser() {
  const raw = localStorage.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function clearAuth() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(FREE_TOOL_KEY);
}

export function isPremiumUser(user) {
  if (!user) return false;
  if (user.premium_until) {
    const until = new Date(user.premium_until);
    if (until > new Date()) return true;
  }
  if (user.is_premium) return true;
  return user.plan === 'premium';
}

export function hasUsedFreeTool() {
  return localStorage.getItem(FREE_TOOL_KEY) === '1';
}

export function markFreeToolUsed() {
  localStorage.setItem(FREE_TOOL_KEY, '1');
}

export function authHeader() {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}
